module.exports = __webpack_public_path__ + "media/packs/images/flags/ER-5c131373a9a10a57bdada94bddbb4717.svg";